import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Subheader from "../../sharedComponent/Subheader";
import Arrow from "../../assets/images/ArrowGreen.svg";
import SaveImg from "../../assets/images/saveImg.svg";
import WhiteSaveImg from "../../assets/images/whiteSave.svg";
import medicineTabsd from "../../assets/images/medicineTabsd.png";
import Star from "../../assets/images/Star.svg";
import { AppContext } from "../../context/AppContext";
import MedicalPrescriptionComp from "./MedicalPrescriptionComp";
import ApiConfig from "../../api/ApiConfig";
import { postMultipartWithAuthCall, postWithAuthCallWithErrorResponse, simpleGetCallWithErrorResponse } from "../../api/ApiServices";
import { notifySuccess } from "../../sharedComponent/notify";
import moment from "moment/moment";

const MyOrderDetails = () => {
  const { id } = useParams();
  const { Prescription, setPrescription } = useContext(AppContext);
const navigate = useNavigate();
  const [orderDetails, setOrderDetails] = useState(null);
      console.log("orderDetails==>>", orderDetails);

  const [cartData, setCartData] = useState([]);
   const [modalVisible, setModalVisible] = useState(false);
  const [reasonCancel, setReasonCancel] = useState("");
  const [isCancelLoading, setIsCancelLoading] = useState(false);
  const [reOrderIsLoading, setReOrderIsLoading] = useState(false);
  const [orderStatus, setOrderStatus] = useState([]);
  const [totalItem, setTotalItem] = useState(0);
  console.log("orderStatusorderStatus==>>", orderStatus);







  useEffect(() => {
    loadOrderDetails();
  }, []);

  const loadOrderDetails = async () => {
    try {
      const res = await simpleGetCallWithErrorResponse(ApiConfig?.ORDER_LIST + "/" + id);
      console.log("orderDetails==>>", res);

      if (res.json?.success) {
        const data = res.json?.data;
        // if (data?.json.status) {
        //   data.status = data.json.status.reverse();
        // }
        setOrderDetails(data);
        setCartData(data?.order_items || []);
        setOrderStatus(data?.order_status);

        let val = 0;
        data?.order_items?.forEach((i) => {
          val += parseFloat(i?.order_item_quantity || 1);
        });
        setTotalItem(val);
      }
    } catch (e) {
   
    }
  };

  if (!orderDetails) {
    return <div>Loading order details...</div>;
  }

  const deliveryAddress = orderDetails?.user_address?.[0];
  const restaurant = orderDetails?.restaurant_address?.[0];
  const bill = orderDetails?.bill_details?.[0];
console.log("deliveryAddress",deliveryAddress);
console.log("restaurant",restaurant);

 const StatusTypeVT = (val) => {
  switch (String(val)) { // convert to string
    case '0': return 'Order Received';
    case '1': return 'Delivery Person Assigned';
    case '2': return 'Order Dispatched';
    case '3': return 'Ready to Delivery';
    case '4': return 'Payment Done';
    case '5': return 'Order Delivered';
    case '6': return 'Returned';
    case '7': return 'Return Back to Warehouse';
    case '8': return 'Delivery Person Reached For Pickup';
    case '9': return 'Delivery Person Reached For Delivery';
    case '10': return 'Cancelled';
    case '11': return 'Pending Refund';
    case '12': return 'Failed Refund';
    case '13': return 'Processed Refund';
    case '14': return 'Order Accepted';
    case '15': return 'Order is being prepared';
    default: return '-';
  }
};


  let mainDiff = 0;

  const checkDiff = () => {
    console.log("pressdedd333");
    const currentDT = moment().format("DD-MM-YYYYTHH:mm");

    console.log("currentDT", currentDT);
    const orderDate =
      moment(orderDetails?.preorder_date).format("DD-MM-YYYY") +
      "T" +
      moment(orderDetails?.preorder_time, "hh:mm a").format("HH:mm");
    console.log("orderDate", orderDate);

    const cd = moment(currentDT, "DD-MM-YYYYTHH:mm");
    console.log("cd", cd);
    const cdd = moment(orderDate, "DD-MM-YYYYTHH:mm");
    console.log("cdd", cdd);
    mainDiff = cd.diff(cdd, "minutes");
    // mainDiff=0
    console.log("mainDiff", mainDiff);
  };
  checkDiff();




  const handleReOrder = async (item) => {
    const requestBody = { order_id: item?.order_id };
    try {
      setReOrderIsLoading(true);
      const { data: req } = await postWithAuthCallWithErrorResponse(ApiConfig.ORDER_REPEAT,  JSON.stringify(requestBody));
      setReOrderIsLoading(false);
      console.log('req111----', req)
      if (req?.json.success) {
                    notifySuccess(req?.json.message)
    
       
      }
    } catch (e) {
      setReOrderIsLoading(false);

    }
  };

  const handleReOrderCancel = async (item) => {
    const requestBody = {
      order_id: item?.order_id,
      order_status: 10,
      cancelReason: reasonCancel,
    };
    try {
      setIsCancelLoading(true);
      const req = await postWithAuthCallWithErrorResponse(ApiConfig.ORDER_STATUS, JSON.stringify(requestBody));
      setIsCancelLoading(false);
      if (req?.json.success) {
                notifySuccess("Order Cancal successfully!")
        navigate('/Home');
        setModalVisible(false);
    
      }
    } catch (e) {
      setIsCancelLoading(false);
      
    }
  };




  const formatPrice = (val) => `₹${Number(val || 0).toFixed(2)}`;



  

  return (
    <div className="DoctorsList myOrders" id="cx-main">
      <Subheader />

      <div className="personalOrders">
        <div className="row">
          {/* Back button */}
          <div className="col-md-12">
            <div className="backAndResult">
              <Link to="/ProfileSetting">
                <img src={Arrow} className="Arrow" alt="" />
                <label htmlFor="" className="keyValues">
                  Showing result for:{" "}
                  <span className="diffColor">Order #{orderDetails?.order_id}</span>
                </label>
              </Link>
            </div>
          </div>

          {/* Delivery + Contact + Actions */}
          <div className="col-md-12">
            <div className="mainCard">
              <div className="row">
                <div className="col-lg-4">
                  <div className="addressDetails">
                    <h1 className="nameOfAddress">Restaurant Address</h1>
                    {restaurant ? (
                      <label>
                        {restaurant?.restaurant_address}, <br />
                        {restaurant?.restaurant_contact}
                    
                      </label>
                    ) : (
                      <label>No address found</label>
                    )}
                  </div>
                   
                </div>

                <div className="col-lg-4">
                  <div className="addressDetails">
                    
                    <h1 className="nameOfAddress">Delivery Address</h1>
                    {deliveryAddress ? (
                      <label>
                        {deliveryAddress?.user_address}, <br />
                        {deliveryAddress?.user_address_mobile}
                       
                      </label>
                    ) : (
                      <label>No address found</label>
                    )}
                 
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="moreActionBtns">
                    <h1 className="nameTag">More Action</h1>
                    {/* <button className="reOrderBtn">
                      <img src={SaveImg} className="SaveImg" alt="" /> Re-Order
                    </button> */}

 <div style={{ marginTop: "20px" }}>
      {/* Cancel Order Button */}
      {["", "7", "10"].includes(orderDetails?.order_status)   ? (
        <></>
      ) : mainDiff <= 2  ? (
        <button
          style={{
            backgroundColor: "#152F4E",
            width: "100%",
            padding: "10px",
            color: "white",
            border: "none",
            borderRadius: "5px",
          }}
          onClick={() => {
            checkDiff();
            if (mainDiff <= 2) setModalVisible(true);
          }}
        >
          Cancel Order
        </button>
      ) : null}

      {/* Reorder Button */}
      {/* {["0", "1", "2", "3", "4", "8", "9", "14"].includes(orderDetails?.order_status) ? (
        <></>
      ) : (
        <button
          style={{
            backgroundColor: "#152F4E",
            width: "100%",
            padding: "10px",
            color: "white",
            border: "none",
            borderRadius: "5px",
            marginTop: "10px",
          }}
          onClick={() => {
            if (!reOrderIsLoading) handleReOrder(orderDetails);
          }}
        >
          {reOrderIsLoading ? "Loading..." : "Reorder"}
        </button>
      )} */}

      {/* Modal */}
      {modalVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.55)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={() => setModalVisible(false)}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "10px",
              padding: "20px",
              width: "90%",
              maxWidth: "400px",
              boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h4>Are you sure you want to cancel the order?</h4>
            {orderDetails?.payment_type !== "COD" && (
              <p style={{ color: "#888" }}>Online order cancellation policy applies.</p>
            )}
            <textarea
              placeholder="Enter reason to cancel the order"
              value={reasonCancel}
              onChange={(e) => setReasonCancel(e.target.value)}
              style={{
                width: "100%",
                height: "80px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                marginTop: "10px",
                padding: "5px",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <button
                style={{
                  width: "48%",
                  border: "2px solid #152F4E",
                  borderRadius: "8px",
                  background: "transparent",
                  color: "#152F4E",
                  padding: "10px",
                }}
                onClick={() => setModalVisible(false)}
              >
                Don’t Cancel
              </button>

              <button
                style={{
                  width: "48%",
                  background: "#152F4E",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px",
                }}
                onClick={() => {
                  if (isCancelLoading) return;
                  checkDiff();
                  if (mainDiff <= 2) handleReOrderCancel(orderDetails);
                  else notifySuccess("You can only cancel order within 2 minutes");
                }}
              >
                {isCancelLoading ? "Cancelling..." : "Cancel Order"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>

                    {/* <button
                      className="downloadBtn"
                      onClick={() => setPrescription(true)}
                    >
                      <img
                        src={WhiteSaveImg}
                        className="downloadImg"
                        alt=""
                      />
                      Download Invoice
                    </button>
                    <MedicalPrescriptionComp /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Order details section */}
         
            <div className="">
              <div className="completeOrderTracker">
                <div className="orderDetails">
                  <div className="row g-4 align-items-start">
                     {cartData.map((item, index) => (
                    <div className="col-lg-4">
                      <div className="mediFlex">
                        {/* <div className="mediBox">
                          <img src={medicineTabsd} alt="" />
                        </div> */}
                        <div className="detailBox">
                          <h1>{item?.order_item_name}</h1>
                          <p>Qty: {item?.order_item_quantity}</p>
                          <p>Price: ₹{item?.order_item_price}</p>
                        </div>
                      </div>
                    </div>
))}
  
            <div className="col-lg-12">
  <div className="mainStepper">
    <ul className="stepper">
      {orderDetails?.status
        ?.slice() // clone array to avoid mutating original
        .reverse()
        ?.map((item, index) => (
          <li
            key={item?.id || index}
            className={`step ${
              index <= orderDetails?.status?.length - 1 ? "active" : ""
            }`}
          >
            <span  className="upper-text text-nowrap" 
       style={{marginLeft:'12px'}}
            >
              {StatusTypeVT(item?.order_status_id)}
            </span>
      
            <span className="dot"></span>
            <span className="lower-text">
              {new Date(item?.created_at)?.toLocaleString?.() || ""}
            </span>
          </li>
        ))}
    </ul>
  </div>
</div>

                  
                  </div>

                  
                </div>
              </div>
            </div>
      

          {/* Total */}
         <div className="mainStepper" >
      <h5 style={{fontWeight: "bold" }}>Bill Details</h5>

      <div className="bill-box" style={{
        background: "#FFF",
        borderRadius: "20px",
        padding: "20px",
        marginTop: "10px"
      }}>
        
        {/* Total Items */}
       

        {/* Delivery Fee */}
        {orderDetails?.bill_details?.[0]?.delivery_fees && (
          <>
            <hr className="my-2" />
            <div className="d-flex justify-content-between mt-1 nameOfAddress
            
            ">
              <span>Delivery Fee</span>
              <span>
                {formatPrice(
                  Number(orderDetails?.bill_details?.[0]?.delivery_fees || 0) +
                    Number(orderDetails?.dc_tax_amount || 0)
                )}
              </span>
            </div>
          </>
        )}

        {/* Packaging Charges */}
        {orderDetails?.packing_charges && (
          <>
            <hr className="my-2" />
            <div className="d-flex justify-content-between mt-1">
              <span>Packaging Charges</span>
              <span>
                {formatPrice(
                  Number(orderDetails?.packing_charges || 0) +
                    Number(orderDetails?.pc_tax_amount || 0)
                )}
              </span>
            </div>
          </>
        )}

        {/* Taxes and Charges */}
        {orderDetails?.bill_details?.[0]?.tax && (
          <>
            <hr className="my-2" />
            <div className="d-flex justify-content-between mt-1">
              <span>Taxes and Charges</span>
              <span>{formatPrice(orderDetails?.bill_details?.[0]?.tax)}</span>
            </div>
          </>
        )}

        {/* Discount */}
        {orderDetails?.order_discount_price && (
          <>
            <hr className="my-2" />
            <div className="d-flex justify-content-between mt-1">
              <span>Discount</span>
              <span>-{formatPrice(orderDetails?.order_discount_price)}</span>
            </div>
          </>
        )}

        <hr className="my-2" />

        {/* Total */}
        <div className="d-flex justify-content-between mt-2">
          <span>Paid Via {orderDetails?.payment_type}</span>
          <strong>
            {formatPrice(orderDetails?.bill_details?.[0]?.total_price)}
          </strong>
        </div>
      </div>

      {/* Footer Total and Payment Type */}
      <div className="col-md-12 text-end mt-3">
        <h4>
          Total Amount: {formatPrice(orderDetails?.bill_details?.[0]?.total_price)}
        </h4>
        <h6>Payment Type: {orderDetails?.payment_type}</h6>
      </div>
    </div>

          {/* Review Section */}
        

        </div>
      </div>
    </div>
  );
};

export default MyOrderDetails;
